var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('HeaderComponentPackage',{attrs:{"apiUrl":_vm.getApiUrl,"themeColor":_vm.getThemeColor,"routes":_vm.menu,"authenticated":_vm.getAuthenticated,"companyObj":_vm.getUserSchool,"logoRoute":"/auth/get-logos-for-given-school"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }